<template>
    <div class="reports-view" v-on:keyup.37="previous" v-on:keyup.39="next">
        <div class="row">
            <div class="col-lg-8">
                <div class="preview" :class="{deactivated: deactivated, temporaryDeactivated: temporaryDeactivated}">
                    <card icon="pe-7s-look" :headline="$t('reports.preview')">
                        <hr />

                        <loader v-if="!hasLoaded"></loader>

                        <div class="overlay-container">
                            <div v-if="hasLoaded" v-html="preview"></div>
                            <div class="overlay"></div>
                        </div>

                        <div class="clearfix"></div>
                    </card>
                </div>
            </div>

            <div class="col-md-4">
                <card icon="pe-7s-user" :headline="$t('reports.customer')">
                    <hr />

                    <loader size="small" v-if="!customers.length"></loader>

                    <label>
                        <input type="checkbox" v-model="onlyDisabled">
                        {{$t('reports.onlyDisabled')}}
                    </label>

                    <template v-if="customers.length">
                        <multiselect v-model="selected"
                                     :options="formattedList"
                                     track-by="label"
                                     label="label"
                                     :close-on-select="true"
                                     :show-labels="false":selectLabel="$t('multiSelect.selectLabel')">
                            <p slot="noResult">{{ $t('multiSelect.noResultsFound') }}</p>
                        </multiselect>

                        <br />

                        <hr />

                        <strong>Gå til</strong><br />

                        <input v-model="selectedIndex" class="form-control">
                    </template>
                </card>

                <div class="priority">
                    <card icon="pe-7s-news-paper" :headline="$t('reports.report')">
                        <hr/>

                        <div class="row">
                            <div class="col-md-6">
                                <strong>{{$t('reports.priority')}}: </strong>
                                <p v-if="currentReport">{{currentReport.priority}}</p>
                            </div>
                            <div class="col-md-6" v-if="customers[selectedIndex]">
                                <strong>Brugertype:</strong>

                                <p v-if="customer && customer.organization && !customer.organization.freemium">Kunde<br><small>Siden {{createdDate}}</small></p>
                                <p v-else>SaaS</p>
                            </div>
                        </div>
                    </card>
                </div>

                <div class="updating-settings">
                    <card icon="pe-7s-settings" :headline="$t('reports.settings')">
                        <hr />

                        <loader v-if="updatingSettings || !hasLoaded" size="small"></loader>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group pull-left">
                                    <strong>{{$t('reports.temporaryDeactivate')}}</strong><br />
                                    <input type="checkbox" v-model="temporaryDeactivated">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group pull-right text-right">
                                    <strong>{{$t('reports.deactivate')}}</strong><br />
                                    <input type="checkbox" v-model="deactivated">
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

                <div class="integrations">
                    <card icon="pe-7s-info" headline="Kunde" description="Integrationer og produkter">
                        <hr />

                        <loader v-if="!hasLoadedCustomer" size="small"></loader>

                        <div class="row" v-else>
                            <div class="col-md-6">
                                <strong>Products:</strong>

                                <div v-for="product in customer.products" :key="product.id">- {{product.discr | capitalize}}</div>
                            </div>

                            <div class="col-md-6">

                                <strong>Integrations:</strong>

                                <div v-for="integration in customer.integrations" :key="integration.id">- {{integration.service.name}}</div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .reports-view {
        .updating-settings {
            position: relative;

            .loader {
                color: #fff;
                position: absolute;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                left: 0;
                top: 0;
                z-index: 99;
                font-size: 20px;
                margin-top: 16px;
                padding: 40px;
            }
        }

        .preview {
            position: relative;

            .overlay-container {
                position: relative;

                .overlay {
                    display: none;
                }
            }

            &.deactivated {
                .overlay {
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                }
            }

            &.temporaryDeactivated {
                .overlay {
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background-color: rgba(23, 0, 47, 0.5);
                }
            }
        }
    }
</style>

<script>
    import Card from '@/app/shared/components/Card'
    import Loader from '@/app/shared/components/Loader.vue'

    const moment = require('moment');

    const CustomerService = require('@/services/customers/CustomerService')
    const PerformanceReportService = require('@/services/performance-report/PerformanceReportService')
    const PerformanceReportBatchService = require('@/services/performance-report/PerformanceReportBatchService')
    const DeactivationService = require('@/services/reports/DeactivationService')

    export default {
        data() {
            return {
                id: null,
                hasLoaded: true,
                customers: [],
                reports: [],
                total: null,
                selected: null,
                selectedIndex: null,
                preview: null,
                deactivated: false,
                temporaryDeactivated: 0,
                updatingSettings: false,
                awaitHasLoaded: false,

                hasLoadedCustomer: false,
                customer: null,

                currentReportType: null,
                currentReport: null,

                onlyDisabled: false,
            }
        },

        watch: {
            selected() {
                if (this.selected) {
                    if (this.selected.value === this.selectedIndex) {
                        return
                    }
                }

                var index = this.customers.map(function(object) {
                    return object.id
                }).indexOf(this.selected.value)

                if (index < 0) {
                    return
                }

                this.selectedIndex = index;

                if (!this.hasLoaded) {
                    if (!this.awaitHasLoaded) {
                        this.awaitHasLoaded = setInterval(this.reload, 500)
                    }

                    return;
                }

                const currentReport = this.reports[index]

                // Todo: This should not be necessarry, but is how the reports are made currently
                this.currentReportType = currentReport.batch.type
                this.currentReport = currentReport

                this.loadPreview()
                this.loadSettings()
                this.loadCustomer()
            },

            selectedIndex() {
                if (this.selectedIndex < 0) {
                    this.selectedIndex = 0
                    return
                }

                if (this.selectedIndex > this.total) {
                    this.selectedIndex = this.total
                    return
                }

                if (this.selected) {
                    var index = this.customers.map(function(object) {
                        return object.id;
                    }).indexOf(this.selected.value);

                    if (index === this.selectedIndex) {
                        return;
                    }
                }

                var customer = this.customers[this.selectedIndex];

                if (!customer) {
                    return;
                }

                this.selected = {
                    label: customer.domain + ' > ' + customer.name,
                    value: customer.id
                };
            },

            temporaryDeactivated() {
                if (!this.hasLoaded) {
                    return;
                }

                if (this.temporaryDeactivated) {
                    this.temporaryDeactivate()
                    return;
                }

                this.temporaryReactivate()
            },

            deactivated() {
                if (!this.hasLoaded) {
                    return;
                }

                if (this.deactivated) {
                    this.unsubcribe()
                    return;
                }

                this.subscribe()
            },

            onlyDisabled() {
                this.reports = []
                this.customers = []
                this.loadReports()
            }
        },

        computed: {
            formattedList() {
                return this.customers.map(function (customer) {
                    return {
                        label: customer.domain + ' > ' + customer.name,
                        value: customer.id
                    };
                });
            },

            createdDate() {
                const customer = this.customers[this.selectedIndex]
                return moment(customer.created.date).format('LL')
            }
        },

        mounted() {
            this.id = this.$route.params.id;
            this.loadReports()
        },

        methods: {
            loadReports(page = 1) {
                let states = ['deactivated']

                if (!this.onlyDisabled) {
                    states.push('content_generated', 'sent')
                }

                const options = {
                    includes: ['batch', 'customer'],
                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'batch.id',
                                    operator: 'eq',
                                    value: this.id,
                                },
                                {
                                    key: 'state',
                                    operator: 'in',
                                    value: states
                                },
                            ]
                        }
                    ],
                    limit: 100,
                    page: page
                };

                PerformanceReportService.findAll(options, (response) => {
                    const body = response.data

                    let reports = this.reports

                    if (body.rows.length === 0) {
                        this.loadCustomers()

                        return
                    }

                    this.total = body.total

                    this.reports = reports.concat(body.rows)

                    this.loadReports(++page)
                })
            },

            loadCustomer() {
                this.hasLoadedCustomer = false

                if (!this.selected) {
                    return
                }

                const data = {
                    includes: [
                        'integrations',
                        'integrations.service',
                        'products',
                        'organization'
                    ]
                };

                CustomerService.find(this.selected.value, data, (response) => {
                    const data = response.data

                    this.customer = data
                    this.hasLoadedCustomer = true
                })
            },

            loadCustomers() {
                this.reports.forEach(report => {
                    this.customers.push(report.customer)
                })

                this.selectedIndex = 0

                const customer = this.customers[0]

                this.selected = {
                    label: customer.domain + ' > ' + customer.name,
                    value: customer.id
                };
            },

            next() {
                this.selectedIndex++
            },

            previous() {
                this.selectedIndex--
            },

            loadPreview() {
                if (!this.selected) {
                    return;
                }

                this.preview = this.reports[this.selectedIndex].content
            },

            loadSettings() {
                this.updatingSettings = true;

                if (!this.selected) {
                    return;
                }

                this.$http.get('users/clients', {params: {
                        includes: ['notificationSubscriptions'],
                        filter_groups: [
                            {
                                filters: [
                                    {
                                        key: 'customer',
                                        operator: 'eq',
                                        value: this.selected.value,
                                    },
                                    {
                                        key: 'notificationSubscriptions.slug',
                                        operator: 'eq',
                                        value: this.currentReportType + '-report', // Todo: This should not be necessarry, but is how the reports are made currently
                                    }
                                ]
                            }
                        ]
                    }}).then((response) => {
                    var body = response.data;

                    this.deactivated = body.rows.length == 0;
                });

                this.temporaryDeactivated = this.reports[this.selectedIndex].state === 'deactivated';

                this.updatingSettings = false;
            },

            reload() {
                if (!this.hasLoaded) {
                    return;
                }

                this.loadPreview();
                this.loadSettings();

                clearInterval(this.awaitHasLoaded);
                this.awaitHasLoaded = null;

            },

            temporaryDeactivate() {
                PerformanceReportService.deactivate(this.currentReport.id)
            },

            temporaryReactivate() {
                PerformanceReportService.reactivate(this.currentReport.id)
            },

            unsubcribe() {
                if (!this.selected) {
                    return;
                }

                PerformanceReportService.unsubscribe(this.selected.value, this.currentReportType)
            },

            subscribe() {
                if (!this.selected) {
                    return;
                }

                PerformanceReportService.subscribe(this.selected.value, this.currentReportType)
            }
        },
        components: {
            Loader,
            Card
        }
    }
</script>
